import * as React from 'react';

export type RequestOpen = React.Dispatch<React.SetStateAction<boolean>>;

export function useOpen(isOpen?: boolean, onRequestOpen?: RequestOpen) {
  const [localIsOpen, setLocalOpen] = React.useState(false);
  const anchorElRef = React.useRef<HTMLButtonElement>(null);

  /** This function abstracts away the logic for self-controlled vs parent controlled */
  const setOpen = React.useCallback<RequestOpen>(
    (open) => {
      if (onRequestOpen) {
        onRequestOpen(open);
      } else {
        setLocalOpen(open);
      }
    },
    [onRequestOpen, setLocalOpen]
  );

  // Self controlled is used only if there is no isOpen prop
  const open = isOpen !== undefined ? isOpen : localIsOpen;

  return { anchorElRef, setOpen, open };
}
